import React from "react";
import { ReactComponent as Sun } from "./Sun.svg";
import { ReactComponent as Moon } from "./Moon.svg";
import { images } from '../../constants';


import "./DarkMode.css";

const DarkMode = ({ setDarkMode }) => {
    function logoDark() {
        document.querySelector(".logo-theme").src = `${images.logoDark}`;
    }

    function logoLight() {
        document.querySelector(".logo-theme").src = `${images.logo}`;
    } 
    
    const setDarkTheme = () => {
        document.querySelector("body").setAttribute("data-theme", "dark");
        setDarkMode(true);
    };

    const setLightTheme = () => {
        document.querySelector("body").setAttribute("data-theme", "light");
        setDarkMode(false);
    };

    
    const toggleTheme = (e) => {
        if (e.target.checked) {
            logoDark();
            setDarkTheme();
        } else {
            logoLight();
            setLightTheme();
        }
    };
    return (
        <div className='dark_mode'>
            <input
                className='dark_mode_input'
                type='checkbox'
                id='darkmode-toggle'
                onChange={toggleTheme}
            />
            <label className='dark_mode_label' htmlFor='darkmode-toggle'>
                <Sun />
                <Moon />
            </label>
        </div>
    );
};

export default DarkMode;
